export default __webpack_public_path__ + "static/media/046-feet.65d3eed8.svg";